<template>
    <div class="nk-footer">
        <div class="container wide-xl">
            <div class="nk-footer-wrap g-2">
                <!-- <div class="nk-footer-copyright"> Made with ♥️</div>
                <div class="nk-footer-links">
                   
                </div> -->
            </div>
        </div>
    </div>

</template>

<script>
import { mainBaseUrl } from '@/apis/appconst';
export default {
    name: 'MainFooter',
    methods: {
        async getMyDtCall() {


        }
    },
    data() {
        return {
            base_url: ""
        };
    },
    mounted() {

        this.base_url = mainBaseUrl;
    },
}
</script>

<style scoped></style>
